import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './plantype.routes';
import addHtml from './modal/add.html';

export class PlanTypeController {
    $http;
    socket;
    awesomeThings = [];
    planTypes = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        // $scope.$on('$destroy', function() {
        //   socket.unsyncUpdates('search');
        // });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/plan_types/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.planTypes = response.data.data;
                        this.socket.syncUpdates('planTypes', this.planTypes);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/plan_types/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.planTypes = response.data.data;
                        this.socket.syncUpdates('planTypes', this.planTypes);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addSpeechType() {
        const planTypes = this.planTypes;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = {};


                $scope.classifications = [
                    {
                        name: 'recommended', value: 1
                    },
                    {
                        name: 'read entire bible', value: 2
                    },
                    {
                        name: 'selected', value: 3,
                    }
                ];

                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;
                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/share_imgs/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/share_imgs/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });



                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.imges = response.data.small_img;
                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.small_imges = response.data.max_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }


                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/plan_types/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    planTypes.push(data);
                }
            }, function () {
            });
    }


    editSpeechType(type, index) {
        const planTypes = this.planTypes;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = angular.copy(type);

                $scope.classifications = [
                    {
                        name: 'recommended', value: 1
                    },
                    {
                        name: 'read entire bible', value: 2
                    },
                    {
                        name: 'selected', value: 3,
                    }
                ];

                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/share_imgs/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/share_imgs/9529/',
                    method: 'POST',
                    autoUpload: true,
                });


                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });



                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.imges = response.data.small_img;

                    }
                };



                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.small_imges = response.data.max_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }





                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {

                        $http.put('/api/plan_types/' + type._id + '/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    planTypes[index] = ret;
                }
            }, function () {
            });
    }



    deleteSpeechType(type, index) {
        this.$http.delete('/api/plan_types/' + type._id + '/').then(response => {
            if (response.status === 200) {
                this.planTypes.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.plantype', [uiRouter])
    .config(routing)
    .component('plantype', {
        template: require('./plantype.html'),
        controller: PlanTypeController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/plantype/plantype.component.js